import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-dialog-confirmation',
  templateUrl: './dialog-confirmation.component.html',
  styleUrls: ['./dialog-confirmation.component.scss']
})
export class DialogConfirmationComponent {
  @ViewChild('confirmDialog') confirmDialog: ModalDirective;

  @Input() title: string;
  @Input() message: string;
  @Input() messageItem: string;
  @Input() confirmText: string;
  @Input() cancelText: string;

  @Output() onConfirm = new EventEmitter<boolean>();
  @Output() onCancel = new EventEmitter<boolean>();

  public show(): void {
    this.confirmDialog.show();
  }

  public hide(): void {
    this.confirmDialog.hide();
  }

  public confirm(): void {
    this.confirmDialog.hide();
    this.onConfirm.emit(true);
  }

  public cancel(): void {
    this.confirmDialog.hide();
    this.onCancel.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-delete-location/dialog-confirmation.component.ts